import type { InputDef, OutputDef } from "./schemaIntrospection";

export const inputDefsCache = new Map<string, InputDef[]>();
export const outputDefsCache = new Map<string, OutputDef[]>();

export function clearSchemaCache(): void {
    inputDefsCache.clear();
    outputDefsCache.clear();
}
